// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { BurnRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Burn';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../../other/useQueryWithOptions';

export const useBurnRequests2Step = <T = TemplateContract<BurnRequest>[]>(
  select?: (data: TemplateContract<BurnRequest>[]) => T,
): UseQueryResult<T, string> => {
  const ledgerApi = useLedgerApiClient();

  return useQueryWithOptions({
    queryKey: ['queryBurnRequestsTwoStep'],
    queryFn: async (_, options) => {
      return ledgerApi.query(options, BurnRequest);
    },
    select,
  });
};
